import { toast } from "react-toastify"
import { _RequestMaintenance, _single } from "../../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../../core/services/dataBean/useDataBean"
import { BasicTable } from "../../../../theme/Component/BasicTable"
import usePaginator from "../../../../theme/Component/usePaginator"
import { useEffect, useState } from "react"
import { BasicButton } from "../../../../theme/Component/BasicButton"
import { InputDate } from "../../../../theme/Input/InputDate"
import { ExportXLSL } from "../../../../theme/Component/ExportXLSX"

interface Form {
    fromDate: string;
    uptoDate: string;
}

export const RequestMaintenanceStatst = () => {

    const { instance, setBean, setLista, bean, lista } = useDataBean(_RequestMaintenance)
    const paginador = usePaginator();

    const [form, setForm] = useState<Partial<Form>>({})

    useEffect(() => getLista(), [])

    const getLista = () => {
        instance.getRequestMaintenanceStats(null, null, {}, form.fromDate, form.uptoDate).then(
            (resp) => {
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'IDMaquina', property: 'IDFixedAssetItem', visible: true },
        { title: 'Código Interno', property: 'FixedAssetItemCode', visible: true },
        { title: 'Maquina', property: 'FixedAssetDescription', visible: true },
        { title: 'Frecuencia de Fallos', property: 'FrecuenciaFallas', visible: true },
        { title: 'Tiempo Detenido (Horas)', property: 'TotalHorasParoHHMM', visible: true },
        { title: 'Tiempo Detenido (Minutos)', property: 'TotalHorasParoMinutos', visible: true },
        { title: 'Observación', property: 'Observacion', visible: true },
    ]

    return (
        <div className="row">
            <div className="col-md-4">
                <InputDate name="" value={form.fromDate} setDate={(e) => { setForm({ ...form, fromDate: e }) }} label="Fecha desde" />
            </div>
            <div className="col-md-4">
                <InputDate name="" value={form.uptoDate} setDate={(e) => { setForm({ ...form, uptoDate: e }) }} label="Fecha hasta" />
            </div>
            <div className="col-md-2 mt-4">
                <BasicButton eventClick={getLista} icon="ri-search-line" children={"buscar"} />
            </div>
            <ExportXLSL customName={"Frecuencias"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={lista} onExport={(name: string) => {
                _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
            }} />
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} />
            </div>
        </div>
    )
}